import { InjectionToken } from "@angular/core";
import { IUserAuthenticationRestClient } from "./i-user-authentication-rest.client";

export const userAuthenticationRestClientInjectionToken: InjectionToken<IUserAuthenticationRestClient> = new InjectionToken<IUserAuthenticationRestClient>("digital-signage.user-dashboard.dashboard-web.UserRestClient");
